import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-aprefund-range',
  templateUrl: './aprefund-range.component.html',
  styleUrls: [],
  standalone: false
})
export class APRefundRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
